module.exports = __webpack_public_path__ + "img/myProfileCover.ad9997c8.jpg";